import React from "react";
import { arrayOf, string } from "prop-types";

import * as S from "./styled";

const DealInformation = ({ dealInformation }) =>
  dealInformation
    ?.filter(info => info?.length)
    ?.map(info => <S.PrefixWithBullet key={info}>{info}</S.PrefixWithBullet>) ??
  null;

DealInformation.propTypes = {
  dealInformation: arrayOf(string)
};

DealInformation.defaultProps = {
  dealInformation: null
};

export default DealInformation;
